module.exports = __webpack_public_path__ + "img/donante-camafeo.b13c1416.png";